
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { BoxStatusType, AttachmentTypeOptions, AttachmentType } from '@/types';

@Component
export default class AttachmentStatusLabel extends Vue {
  @Prop({ type: String, default: 'todo' }) readonly status!: BoxStatusType | null
  @Prop({ type: String, default: 'altri' }) readonly type!: AttachmentType

  get boxText(): string {
    switch (this.status) {
      case null:
      case 'todo':
        return 'Da fare';

      case 'done':
        return 'Fatto';

      case 'waiting':
        return 'In attesa';

      case 'na':
        return 'Non applicabile';

      default:
        break;
    }

    return 'Sconosciuto';
  }

  get boxColor(): string {
    switch (this.status) {
      case 'na':
      case 'todo':
        return 'grey';

      case 'done':
        return 'success';

      case 'waiting':
        return 'orange';

      default:
        break;
    }

    return '';
  }

  get boxDark(): boolean {
    switch (this.status) {
      case 'todo':
      case 'done':
      case 'waiting':
        return true;

      case 'na':
        return false;

      default:
        break;
    }

    return true;
  }

  get boxOutlined(): boolean {
    switch (this.status) {
      case 'todo':
      case 'done':
      case 'waiting':
        return false;

      case 'na':
        return true;

      default:
        break;
    }

    return false;
  }

  get boxLabel(): string {
    return this.type in AttachmentTypeOptions
      ? AttachmentTypeOptions[this.type]
      : 'Sconosciuto';
  }
}

